var React = require('react');

function AppCardStarInline (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 10C0 4.47715 4.47715 0 10 0V0C15.5228 0 20 4.47715 20 10V10C20 15.5228 15.5228 20 10 20V20C4.47715 20 0 15.5228 0 10V10Z","fill":"white","key":0}),React.createElement("path",{"d":"M9.99166 1.66667C5.39166 1.66667 1.66666 5.4 1.66666 10C1.66666 14.6 5.39166 18.3333 9.99166 18.3333C14.6 18.3333 18.3333 14.6 18.3333 10C18.3333 5.4 14.6 1.66667 9.99166 1.66667ZM13.525 15L9.99999 12.875L6.47499 15L7.40832 10.9917L4.29999 8.3L8.39999 7.95L9.99999 4.16667L11.6 7.94167L15.7 8.29167L12.5917 10.9833L13.525 15Z","fill":"#328DFF","key":1})]);
}

AppCardStarInline.defaultProps = {"width":"20","height":"20","viewBox":"0 0 20 20","fill":"none"};

module.exports = AppCardStarInline;

AppCardStarInline.default = AppCardStarInline;
